import PropTypes from 'prop-types'

import AtomBadge, {atomBadgeDesigns, atomBadgeSizes, atomBadgeTypes} from '@s-ui/react-atom-badge'

const CardRatingTags = ({tags}) => {
  return (
    <ul className="mt-CardRating-tags" aria-label="Aspectos valorados">
      {tags.map((label, index) => (
        <li key={index} className="mt-CardRating-tag">
          <AtomBadge
            design={atomBadgeDesigns.SOFT}
            label={label}
            size={atomBadgeSizes.LARGE}
            type={atomBadgeTypes.NEUTRAL}
          />
        </li>
      ))}
    </ul>
  )
}

CardRatingTags.displayName = 'CardRatingTags'

CardRatingTags.propTypes = {
  tags: PropTypes.array.isRequired
}

export default CardRatingTags
